// Replaces the jQuery minicolors plugin on .color-picker-editor inputs (Recruiter/Edit,
// Enhance Job tab). The text input keeps its name and value, so the same hex
// string is posted; a native colour swatch beside it edits that value.
const hex = /^#[0-9a-f]{6}$/i;

function enhanceColor(input) {
  if (input.dataset.enhanced) {
    return;
  }

  input.dataset.enhanced = 'true';

  const swatch = document.createElement('input');
  swatch.type = 'color';
  swatch.className = 'h-[34px] w-12 shrink-0 cursor-pointer rounded border border-slate-300 bg-white p-0.5';
  swatch.setAttribute('aria-label', `${input.name} colour`);

  const wrapper = document.createElement('div');
  wrapper.className = 'flex items-center gap-2';
  input.replaceWith(wrapper);
  wrapper.append(swatch, input);

  const fromText = () => {
    if (hex.test(input.value.trim())) {
      swatch.value = input.value.trim().toLowerCase();
    }
  };

  swatch.addEventListener('input', () => {
    input.value = swatch.value.toLowerCase();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  input.addEventListener('input', fromText);
  fromText();
}

export function enhanceColors(root = document) {
  root.querySelectorAll('input.color-picker-editor').forEach(enhanceColor);
}
